export class NoopStorage {
  setItem(key: string, value: string) {}
  getItem(key: string) { return null; }
  removeItem(key: string) {}
  clear() {}
}